import styled from '@emotion/styled';
import { TrashAlt } from '@emotion-icons/fa-solid';
import React from 'react';

const DeleteButtonArea = styled.div`
  transition: background 0.4s ease-out;
  width: 45px;
  background: rgb(82, 6, 6);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  :hover {
    background: rgb(126, 10, 10);
  }
`;

const TrashColored = styled(TrashAlt)`
  color: red;
  width: 50%;
  transform: scale(1, 1.25);
  box-shadow: 0 0 5px #2d0404;
`;

export interface IDeleteProps {
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const DeleteButton = (props: IDeleteProps) => {
  return (
    <DeleteButtonArea
      role={'delete-button'}
      onClick={(e) => {
        if (props.onClick) props.onClick(e);
      }}
    >
      <TrashColored role={'img'} data-testid={'trash-can-icon'} />
    </DeleteButtonArea>
  );
};
